import React, { cloneElement, FC } from 'react';
import { TranslationKey, useTranslations } from '@lang';
import { StyledLabel } from '../StyledLabel';
import Error from '../Error';
import { RadioFlexField } from './RadioFlexField';
import AssistiveText from '../FormElements/styled/AssistiveText';
import { RadioGroupFlexFieldWrapper } from './RadioGroupFlexField.styles';

type RadioGroupFlexFieldProps = {
  name: string;
  isDisabled?: boolean;
  input: {
    value: string;
    onChange: React.Dispatch<React.SetStateAction<string>>;
  };
  meta: {
    error: string;
    touched: boolean;
  };
  error: boolean;
  children?: any;
  label?: string;
  options?: { label: string; value: string; id: TranslationKey }[];
  key?: number;
  isRequired?: boolean;
  showBackground?: boolean;
};

export const RadioGroupFlexField: FC<RadioGroupFlexFieldProps> = ({
  name = '',
  input: { onChange, value },
  isDisabled = false,
  meta,
  error = meta.touched && meta.error,
  label,
  options,
  isRequired = false,
}) => {
  const { t } = useTranslations();

  return (
    <>
      <StyledLabel error={error} isRequired={isRequired}>
        {label}
      </StyledLabel>
      <RadioGroupFlexFieldWrapper error={error}>
        {options &&
          options.map((option) => (
            <React.Fragment key={option.value}>
              {cloneElement(
                <RadioFlexField key={option.value} value={option.value}>
                  <>{t(option.id)}</>
                </RadioFlexField>,
                {
                  isChecked: value === option.value,
                  onChange,
                  isDisabled,
                  error,
                  name,
                }
              )}
            </React.Fragment>
          ))}
      </RadioGroupFlexFieldWrapper>
      {error && (
        <AssistiveText>
          <Error error={error} />
        </AssistiveText>
      )}
    </>
  );
};
